<template>
  <footer class="p-12 bg-black text-custom-orange">
    <div class="grid grid-cols-[auto,_1fr] items-center justify-items-start gap-x-4 gap-y-2 w-fit mx-auto">
      <div class="bg-custom-orange w-4 h-full rounded-lg"></div>
      <p class="text-2xl">Mamema Tree Kft.</p>
      <font-awesome-icon icon="fa-solid fa-phone" class="justify-self-center" />
      <a href="tel:+36302020624" class="underline md:hover:text-white md:transition-colors">+36302020624</a>
      <font-awesome-icon icon="fa-solid fa-envelope" class="justify-self-center" />
      <a href="mailto:favagasgyor@gmail.com" class="underline md:hover:text-white md:transition-colors">
        favagasgyor@gmail.com</a>
      <font-awesome-icon icon="fa-brands fa-facebook" class="justify-self-center" />
      <a href="https://www.facebook.com/favagaskomarom" target="_blank"
        class="underline md:hover:text-white md:transition-colors">
        facebook.com/favagaskomarom
      </a>
      <font-awesome-icon icon="fa-brands fa-facebook" class="justify-self-center" />
      <a href="https://www.facebook.com/tetomosaskomarom" target="_blank"
        class="underline md:hover:text-white md:transition-colors">
        facebook.com/tetomosaskomarom
      </a>
      <font-awesome-icon icon="fa-brands fa-instagram" class="justify-self-center" />
      <a href="https://www.instagram.com/favagaskomarom" target="_blank"
        class="underline md:hover:text-white md:transition-colors">
        instagram.com/favagaskomarom
      </a>
    </div>
    <div class="text-center mt-12">
      <p>
        Copyright <font-awesome-icon icon="fa-solid fa-copyright" />
        2023 Mamema Tree Kft. Minden jog fenntartva!
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent",
  props: {},
  methods: {},
  computed: {},
};
</script>